'use client';

import PropTypes from 'prop-types';
import FeaturedPortfolioCollections from '@/components/portfolio/FeaturedPortfolioCollections';
import WebsiteInteriorScrollLayout from './WebsiteInteriorScrollLayout';

export default function PortfolioPage({ collectionTiles, title, intro }) {
  return (
    <WebsiteInteriorScrollLayout>
      <FeaturedPortfolioCollections collectionTiles={collectionTiles} title={title} intro={intro} />
    </WebsiteInteriorScrollLayout>
  );
}

PortfolioPage.propTypes = {
  title: PropTypes.string,
  intro: PropTypes.string,
  collectionTiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      coverImage: PropTypes.string,
      hoverSlides: PropTypes.array,
    }),
  ).isRequired,
};
